__turbopack_context__.v({
  "panel": "collapsible-purchase-section-module-scss-module__pkPkLa__panel",
  "panel-content-collapsed": "collapsible-purchase-section-module-scss-module__pkPkLa__panel-content-collapsed",
  "panel-toggler": "collapsible-purchase-section-module-scss-module__pkPkLa__panel-toggler",
  "panel-toggler-static": "collapsible-purchase-section-module-scss-module__pkPkLa__panel-toggler-static",
  "radio": "collapsible-purchase-section-module-scss-module__pkPkLa__radio",
  "radio-controlled-content": "collapsible-purchase-section-module-scss-module__pkPkLa__radio-controlled-content",
  "radio-controlled-title": "collapsible-purchase-section-module-scss-module__pkPkLa__radio-controlled-title",
  "radio-controlled-title-wrapper": "collapsible-purchase-section-module-scss-module__pkPkLa__radio-controlled-title-wrapper",
  "uncontrolled-container": "collapsible-purchase-section-module-scss-module__pkPkLa__uncontrolled-container",
  "uncontrolled-content-wrapper": "collapsible-purchase-section-module-scss-module__pkPkLa__uncontrolled-content-wrapper",
});
